var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',[_c('v-card-title',{staticClass:"module-title pa-4 pb-0 pa-md-6 pb-md-0",class:_vm.moduleClass},[_c('h2',{staticClass:"text-capitalize mb-0"},[_vm._v(_vm._s(_vm.title))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }